import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
    Button, Form, Input, message, Radio, InputNumber, Space
} from 'antd';
import { formItemLayout, tailLayout } from './ModalLayout';
import { useTranslation } from 'react-i18next';
import * as Service from '../core/Service';

const VehicleForm = (props) => {
  const {t} = useTranslation();

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const {
    selectedRecord,
    openModal
  } = props;

  useEffect(() => {
    console.log('reset data')
    form.resetFields();
    console.log('setting data', selectedRecord)
    setFormData(selectedRecord);
  }, [form, selectedRecord]);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [form, formData]);

  const onFinish = async (formObj) => {
    let method = `POST`;
    let endpoint = `/api/vehicle`;

    console.log("vehicle_id", formData.vehicle_id);
    let bodyObj = _.clone(formObj);
    if (formData.vehicle_id > 0) {
      bodyObj.vehicle_id = formData.vehicle_id;
      method = `PUT`;
    }

    try {
      let resp = await Service.call(method, endpoint, bodyObj);
      if (resp.errorMessage) {
        if (resp.status === -1
          && resp.errorCode === -210001
          && resp) {
            message.error(t('driver_vehicle.invalid_license_or_callsign'));
          }
        else {
          message.error(resp.errorMessage);
        }
        return;
      }
      message.success(t('common.success'));
      return openModal(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Form
      {...formItemLayout}
      form={form}
      onFinish={onFinish}
      initialValues={formData}
    >
      <Form.Item
        name="vehicle_license_no"
        label={t('vehicle.vehicle_license_no')}
        rules={[{ required: true, message: `${t('common.please_input')}` }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="call_sign"
        label={t('vehicle.call_sign')}
        rules={[{ required: true, message: `${t('common.please_input')}` }]}
      >
        <Input onChange={ e => form.setFieldsValue({"call_sign" : e.target.value.toUpperCase()}) } />
      </Form.Item>
      <Form.Item
        name="vehicle_type_id"
        label={t('vehicle.vehicle_type')}
        style={!('vehicle_id' in selectedRecord) && { display: 'none'}}
      >
        <Radio.Group>
          <Space direction="vertical">
            <Radio value={0}>新界的士 NT Taxi</Radio>
            <Radio value={1}>市區的士 Urban Taxi</Radio>
            <Radio value={2}>大嶼山的士 Lantau Taxi</Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name="seat_number"
        label={t('vehicle.seat_number')}
        style={!('vehicle_id' in selectedRecord) && { display: 'none'}}
      >
        <Radio.Group>
          <Space direction="vertical">
            <Radio value={4}>4</Radio>
            <Radio value={5}>5</Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button
          type="primary"
          htmlType="submit"
        >
          {t('common.submit')}
        </Button>
      </Form.Item>
    </Form >
  );
}

export default VehicleForm;
